export default __webpack_public_path__ + "static/media/7d46b4ebe44b3fc70cb822cdfb359f34.png";